export default __webpack_public_path__ + "static/media/Group-105.386409e9.svg";